import React, { FC, ReactNode } from 'react'
import './icon.scss'

export const HouseHighlighterIcon: FC<ReactNode> = () => {
  return (
    <div className='icon-container'>
      <img
        srcSet={
          'https://www.static-immobilienscout24.de/statpic/sales-journey/hos/rle-wizard/icons/f9bd99bf43a8c4961787364ba92f9163_IS24_House_highlighter.png, ' +
          'https://www.static-immobilienscout24.de/statpic/sales-journey/hos/rle-wizard/icons/eae250e74f85b577f98c6de1a0c4e57d_IS24_House_highlighter@2x.png 2x, ' +
          'https://www.static-immobilienscout24.de/statpic/sales-journey/hos/rle-wizard/icons/b30ea21e5ae58b0acace704c1b69f47f_IS24_House_highlighter@3x.png 3x'
        }
        src={
          'https://www.static-immobilienscout24.de/statpic/sales-journey/hos/rle-wizard/icons/f9bd99bf43a8c4961787364ba92f9163_IS24_House_highlighter.png'
        }
        width={128}
        height={128}
        alt={''}
      />
    </div>
  )
}
